<template>
  <div class="yxtbiz-ai-training-design">
    <main-list v-if="!id" @goDetail="goDetail" />
    <main-detail v-else :id="id" @goback="goback"/>
  </div>
</template>

<script>
import mainList from './components/main-list.vue';
import mainDetail from './components/main-detail.vue';

export default {
  name: 'YxtbizAiTrainingDesign',
  components: {
    mainList,
    mainDetail
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    goDetail(id) {
      const { name, params, query } = this.$route;
      this.$router
        .push({ name, params, query: { ...query, aiid: id } })
        .catch(err => err);
    },
    goback() {
      const route = this.$route;
      const query = { ...route.query };
      delete query['aiid'];
      this.$router.push({ query });
    }
  },
  computed: {
    id() {
      return this.$route.query.aiid;
    }
  }
};
</script>
